/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KpiValueFormat } from './kpi-value-format';
import { ChartConfigurationSchema } from './chart-configuration-schema';
import { KpiParameterDto } from './kpi-parameter-dto';


export interface DashboardBundleKpiConfigDto { 
    /**
     * Metric presentation type. count, amount and percentage render one value; trend returns one row per time bucket (bucket, value) and needs valueFormat; chart requires chartConfig.
     */
    type: DashboardBundleKpiConfigDto.TypeEnum;
    /**
     * How a trend KPI\'s values are formatted. Required when type is trend; must be null or omitted for every other type.
     */
    valueFormat?: KpiValueFormat | null;
    /**
     * Parameterized, read-only SQL using {{placeholders}}.
     */
    sql: string;
    /**
     * Required when type is chart; null for scalar metric types.
     */
    chartConfig?: ChartConfigurationSchema | null;
    /**
     * Parameters the SQL declares as `{{placeholders}}`, with their type, default and option source.
     */
    parameters?: Array<KpiParameterDto>;
}
export namespace DashboardBundleKpiConfigDto {
    export const TypeEnum = {
        Amount: 'amount',
        Count: 'count',
        Chart: 'chart',
        Percentage: 'percentage',
        Trend: 'trend'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


